module.exports = __webpack_public_path__ + "img/de_de.8d701c0b.png";